import { useNavigate } from 'react-router-dom'
import { Ticket, Camera, ShoppingBag, Building2 } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

interface Category {
  icon: React.ElementType
  label: string
  description: string
  to: string
  available: boolean
  type?: 'internal' | 'hub'
}

const CATEGORIES: Category[] = [
  {
    icon: Ticket,
    label: 'Sale Events',
    description: 'Kelola penjualan tiket konser, fanmeeting, dan event lainnya. Atur fase penjualan, konfirmasi order, dan absensi.',
    to: '',
    available: true,
    type: 'hub',
  },
  {
    icon: Camera,
    label: 'Cheki',
    description: 'Penjualan sesi foto polaroid bersama member. Coming soon.',
    to: '',
    available: false,
  },
  {
    icon: ShoppingBag,
    label: 'Merch',
    description: 'Penjualan merchandise resmi: album, photobook, lightstick, dan lainnya. Coming soon.',
    to: '',
    available: false,
  },
]

export default function SalesHubLandingPage() {
  const navigate = useNavigate()
  const { isGroupManager } = useAuth()

  return (
    <div className="max-w-4xl mx-auto p-8 pt-12">

      {/* Header */}
      <div className="mb-10">
        <h1 className="text-2xl font-bold text-white mb-2">Sales Hub</h1>
        <p className="text-zinc-500 text-sm">Pilih kategori penjualan yang ingin dikelola.</p>
      </div>

      {/* Category cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {CATEGORIES.map(({ icon: Icon, label, description, to, available, type }) => (
          <div
            key={label}
            onClick={() => {
              if (!available) return
              if (type === 'hub') {
                const token = localStorage.getItem('admin_token')
                const refresh = localStorage.getItem('admin_refresh')
                const expires = localStorage.getItem('admin_expires')
                if (!token || !refresh || !expires) return
                const params = new URLSearchParams({ token, refresh, expires })
                window.location.href = `${import.meta.env.VITE_HUB_URL}/auth/handoff?${params}`
              } else {
                navigate(to)
              }
            }}
            className={`
              rounded-xl border bg-zinc-900 p-6 flex flex-col gap-4 transition-all
              ${available
                ? 'border-zinc-800 hover:border-zinc-600 cursor-pointer group'
                : 'border-zinc-800/50 opacity-50 cursor-not-allowed'
              }
            `}
          >
            {/* Icon */}
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
              available ? 'bg-zinc-800 group-hover:bg-zinc-700' : 'bg-zinc-800/50'
            } transition-colors`}>
              <Icon size={20} className={available ? 'text-yellow-400' : 'text-zinc-600'} />
            </div>

            {/* Content */}
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1.5">
                <h2 className="text-sm font-semibold text-white">{label}</h2>
                {!available && (
                  <span className="text-[9px] font-semibold text-zinc-600 uppercase tracking-widest border border-zinc-800 rounded px-1.5 py-0.5">
                    Soon
                  </span>
                )}
              </div>
              <p className="text-xs text-zinc-500 leading-relaxed">{description}</p>
            </div>

            {/* CTA */}
            {available && (
              <p className="text-xs font-semibold text-yellow-500 group-hover:text-yellow-400 transition-colors">
                Kelola →
              </p>
            )}
          </div>
        ))}
      </div>

      {!isGroupManager && (
        <div className="mt-10">
          <h2 className="text-xs font-semibold text-zinc-500 uppercase tracking-widest mb-4">Platform</h2>
          <div
            className="rounded-xl border border-zinc-800 bg-zinc-900 p-6 flex items-center gap-4 cursor-pointer hover:border-zinc-600 group transition-all max-w-xs"
            onClick={() => navigate('/sales/tenants')}
          >
            <div className="w-10 h-10 rounded-lg bg-zinc-800 group-hover:bg-zinc-700 flex items-center justify-center transition-colors shrink-0">
              <Building2 size={20} className="text-yellow-400" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-white">Tenants</h3>
              <p className="text-xs text-zinc-500 mt-0.5">Kelola organisasi dan akun organizer.</p>
            </div>
            <p className="text-xs font-semibold text-yellow-500 group-hover:text-yellow-400 transition-colors shrink-0">Kelola →</p>
          </div>
        </div>
      )}

    </div>
  )
}
